import React from "react";

const Loader = () => {
  return (
    <div className="custom-loaderbg">
      <div className="custom-loader"></div>
    </div>
  );
};

export default Loader;
